import { useState } from "react";

import styles from "./mysteryLogin.module.css";
import AppBar from "../../components/appBar/appBar";
import PopupWithImage from "../../components/popupWithImage/popupWithImage";
import ImgBuilder from "../../assets/ImgBuilder";
import AbortGame from "../../components/abortGame/abortGame";

import { useTranslation } from "react-i18next";

const MysteryLogin = () => {
  const { t } = useTranslation();
  const [wrongLogin, setWrongLogin] = useState(false);

  const [mystery, setMystery] = useState("");
  const words = t("end.codes", { returnObjects: true })


  const handleMysteryLogin = () => {
    if (words.includes((mystery.toUpperCase()))){
      window.location.href = "https://drive.google.com/file/d/1TiClv-bvv_8U_zHStnqgRs3Lm6B38oi_/view?usp=drivesdk";
    } else{
      setWrongLogin(true)
      setMystery("")
    }
  };

  return (
    <div className={styles.wrapperLogin}>
      <AppBar />
      <AbortGame />
      {wrongLogin &&
        <PopupWithImage
          name={t(`pop_up_notifications.wrong_mystery_name`)}
          description={t(`pop_up_notifications.wrong_mystery_description`)}
          button={t(`pop_up_notifications.wrong_mystery_button`)}
          type={"confirmation"}
          defContinue={() => setWrongLogin(false)}
        />    
      }
      {/* {!isLoaded && <div className={styles.loaderWrapper}><div className={styles.loader}></div></div>} */}
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>

      <div className={styles.loginBox} style={{ "--hdelay": "300ms" }}>
        <div className={styles.textUpperLogin}>
          
          <p className={styles.loginTop}>{t(`mystery.top`)}</p>
          <p className={styles.loginTopDescription}>{t(`mystery.description`)}</p>
        </div>
        <input 
          autoComplete="off"
          type="text" 
          className={styles.loginInput}
          placeholder={t(`mystery.placeolder`)}
          value={mystery}
          onChange={(e) => setMystery(e.target.value)}
        />
        <button onClick={() => handleMysteryLogin()} className={styles.loginButton}>{t(`mystery.proceed`)}</button>
      </div>

    </div>
  );
};

export default MysteryLogin;
